module.exports = __webpack_public_path__ + "img/icon-white.e7c5083f.svg";